export type CampaignCountdown = {
  days: number
  hours: number
  minutes: number
  seconds: number
  expired: boolean
}

export function getCountdownUntil(
  endsAt: string,
  now = new Date()
): CampaignCountdown {
  const endMs = new Date(endsAt).getTime()
  const nowMs = now.getTime()
  const invalid = !Number.isFinite(endMs)
  const remainingMs = invalid ? 0 : Math.max(0, endMs - nowMs)
  const totalSeconds = Math.floor(remainingMs / 1000)

  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    expired: invalid || endMs <= nowMs,
  }
}
